<app-header></app-header>

<section class="bv-reports-page">
  <div class="bv-reports-page__panel">
    <p class="bv-reports-page__intro">{{ "reportsDesc" | i18n }}</p>
    <app-report-list [reports]="reports()"></app-report-list>
  </div>
</section>
